var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var jwtDecode = require('jwt-decode')

module.exports = function () {
  // init
  var Session = BaseModel.extend({
    url: Config.api.host + '/authentication',

    idAttribute: '_id',
    defaults: {
      logged_in: false,
      accessToken: localStorage.getItem(Config.tokenHandle)
    },
    validation: {
    },
    initialize: function () {
      var self = this
      this.user = App.globalChannel.request('user:entity:new')

      jQuery.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        // if (!options.beforeSend) {
        options.beforeSend = function (xhr) {
          xhr.setRequestHeader('Content-Type', 'application/json')
          if (typeof self.get('accessToken') !== 'undefined') {
            if (self.get('accessToken') !== null) {
              // xhr.setRequestHeader('authentication-token', _this.get('token'))
              xhr.setRequestHeader('Authorization', self.get('accessToken'))
            }
          }
        }
      // }
      })

    // jQuery.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    //   if (!options.beforeSend) {
    //     options.beforeSend = function (xhr) {
    //       xhr.setRequestHeader('Content-Type', 'application/json')
    //       if (typeof _this.get('token') !== 'undefined') {
    //         if (_this.get('token') !== null) {
    //           // xhr.setRequestHeader('authentication-token', _this.get('token'))
    //           xhr.setRequestHeader('Authorization', _this.get('token'))
    //         }
    //       }
    //     }
    //   }
    // })
    },
    // parse: function (response, options) {
    //   console.log(response)
    // },
    login: function (creds, callback) {
      var self = this
      creds = Object.assign({'strategy': 'local'}, creds)
      console.log(creds)
      // Do a POST to /session and send the serialized form creds
      this.save(creds, {
        success: function (model, response) {
          localStorage.setItem(Config.tokenHandle, model.get('accessToken'))

          var decoded = jwtDecode(model.get('accessToken'))
          self.user.set(decoded.data)

          self.set('accessToken', model.get('accessToken'))
          self.set('logged_in', true)

          return callback(null, response.responseJSON)
        },
        error: function (model, response) {
          self.set('logged_in', false)
          return callback(response.responseJSON)
        }
      })
    },
    verify: function (callback) {
      var self = this

      if (!this.get('accessToken')) return callback('no-token')
      console.log('verify')
      var data = { 'accessToken': self.get('accessToken') }
      var request = new XMLHttpRequest()
      request.open('POST', Config.api.host + '/authentication', true)
      request.setRequestHeader('Content-Type', 'application/json')

      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          var response = JSON.parse(request.responseText)

          localStorage.setItem(Config.tokenHandle, response.accessToken)
          console.log(response.accessToken)
          var decoded = jwtDecode(response.accessToken)
          self.user.set(decoded.data)

          self.set('accessToken', response.accessToken)
          self.set('logged_in', true)

          return callback(null, true)
        } else {
          // We reached our target server, but it returned an error
          self.set('logged_in', false)
          return callback(JSON.parse(request.responseText))
        }
      }

      request.onerror = function () {
        return callback('error')
      // There was a connection error of some sort
      }

      request.send(JSON.stringify(data))
    },
    logout: function () {
      console.log('logout')
      console.warn('temporarely disabled')

      localStorage.removeItem(Config.tokenHandle)
      location.reload()
    }
  })

  // //
  var API = {
    newSessionEntity: function () {
      return new Session()
    }
  }

  App.globalChannel.reply({
    'session:entity:new': API.newSessionEntity
  })

//
}



// WEBPACK FOOTER //
// ./js/entities/session.js